'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { Anchor } from '@qogita/ui/v2/anchor'
import { Button } from '@qogita/ui/v2/button'
import { useEffect } from 'react'
import { browserLogger } from 'src/core/logger/browser'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string; fingerprint?: string; details?: unknown }
  reset: () => void
}) {
  useEffect(() => {
    // Override custom fingerprints to ensure the error creates
    // a new issue related to the uncaught error event.
    //
    // this could be useful as a shared hook to use in all error pages when we have more than one page
    const fingerprint = error.fingerprint
      ? `${error.fingerprint} unhandled`
      : ''

    browserLogger.error(error, {
      fingerprint,
      is_error_boundary: true,
      digest: error.digest,
      error_source: error.digest ? 'server' : 'client',
    })
  }, [error])

  return (
    <div className="mx-auto flex flex-col items-center justify-center gap-4 px-4 py-40">
      <h1 className="text-2xl sm:text-3xl">Something went wrong</h1>
      <p>
        We are working to resolve this. Please{' '}
        <Button variant="inline-text" onClick={() => reset()}>
          try again
        </Button>{' '}
        or{' '}
        <Anchor
          variant="inline-text"
          href="mailto:support@qogita.com"
          hideProgressBar
        >
          contact us
        </Anchor>{' '}
        if it persists.
      </p>
    </div>
  )
}
